export default __webpack_public_path__ + "static/media/080_finish_bad.last.e2d30b13.avif";